module.exports = "/assets/data/3143daea0913e331e43fda0d269d35c6-CW11.data.json";